import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { reactScrollCollapse } from 'react-scroll-collapse';
import accountReducer from 'reducer/account';
import authReducer from 'reducer/auth';
import companyReducer from 'reducer/company';
import contactReducer from 'reducer/contact';
import fieldReducer from 'reducer/field';
import mainReducer from 'reducer/main';
import newsReducer from 'reducer/news';
import ormReducer from 'reducer/orm';
import profileReducer from 'reducer/profile';
import remindersReducer from 'reducer/reminders';
import userReducer from 'reducer/user';

import integrationReducer from './integration';
import portfolioReducer from './portfolio';
import viewsReducer from './view';

const createReducer = (history: History) => ({
  main: mainReducer,
  auth: authReducer,
  router: connectRouter(history),
  orm: ormReducer,
  account: accountReducer,
  reminders: remindersReducer,
  company: companyReducer,
  contact: contactReducer,
  user: userReducer,
  news: newsReducer,
  field: fieldReducer,
  portfolio: portfolioReducer,
  profile: profileReducer,
  integration: integrationReducer,
  view: viewsReducer,
  reactScrollCollapse,
});

export default createReducer;
